import HTMLReactParser from '../lib/index.js';
export { attributesToProps, Comment, domToReact, Element, htmlToDOM, ProcessingInstruction, Text } from '../lib/index.js';
export default HTMLReactParser.default || HTMLReactParser;